export const TOGGLE_APP_NAV_DRAWER = "TOGGLE_APP_NAV_DRAWER"